export default __webpack_public_path__ + "static/media/danskgo-screenshot-06.14406281.png";